import React from 'react';
import { Box, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { EmailOutlinedIcon, UploadFileOutlinedIcon } from 'icons/materialIcons';
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';
import TeamIconComponent from 'team/shared/components/TeamIconComponent';

const TeamAddMemberSidebar = ({ menuOptions, selectedOption, onMenuClick }) => {
    return (
        <Box sx={{
            width: '15rem',
            backgroundColor: '#ffffff',
            overflow: 'auto',
            padding: '1.5rem 1rem 1rem 1.5rem',
            borderRight: '0.0625rem solid #e0e0e0'
        }}>
            <Box sx={{ marginTop: 1 }}>
                <List>
                    {menuOptions.map((menuOption) => (
                        <ListItem
                            key={menuOption.key}
                            onClick={() => onMenuClick(menuOption.key)}
                            sx={{
                                paddingLeft: '1rem',
                                paddingRight: '0.5rem',
                                paddingTop: '0.25rem',
                                paddingBottom: '0.25rem',
                                whiteSpace: 'nowrap',
                                minHeight: '2.5rem',
                                cursor: 'pointer',
                                borderRadius: '0.25rem',
                                marginLeft: '0.5rem',
                                marginBottom: '0.5rem',
                                width: '11rem',
                                backgroundColor: selectedOption === menuOption.key ? 'rgba(0, 0, 0, 0.04)' : 'transparent',
                                '&:hover': {
                                    backgroundColor: 'rgba(0, 0, 0, 0.04)',
                                }
                            }}
                        >
                            <ListItemIcon sx={{
                                minWidth: '2rem',
                                marginRight: 0.5
                            }}>
                                {React.cloneElement(menuOption.icon, {
                                    sx: { fontSize: '1.25rem' }
                                })}
                            </ListItemIcon>
                            <ListItemText
                                primary={menuOption.title}
                                primaryTypographyProps={{
                                    sx: {
                                        fontSize: '0.8rem',
                                        fontWeight: 600,
                                        color: "#4f4f4f",
                                        marginLeft: 0
                                    }
                                }}
                            />
                        </ListItem>
                    ))}
                </List>
            </Box>
        </Box>
    );
};

export default TeamAddMemberSidebar;

